const VERSION = "2.1.2";
export {
  VERSION
};
